"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const libConfig_1 = __importDefault(require("./libConfig"));
const mathFunctionMap = {
    up: Math.ceil,
    down: Math.floor,
    off: Math.round,
    '': undefined,
};
function getDisplayRoundNumber(value, rounding = libConfig_1.default.rounding) {
    if (value == null)
        return '0';
    value = Number(value);
    const mathFunction = mathFunctionMap[rounding.type];
    if (mathFunction == null) {
        return value.toFixed(rounding.digits);
    }
    const digitsAdjust = Math.pow(10, rounding.digits);
    return (mathFunction(value * digitsAdjust) / digitsAdjust).toFixed(rounding.digits);
}
exports.default = getDisplayRoundNumber;
//# sourceMappingURL=getDisplayRoundNumber.js.map